export default __webpack_public_path__ + "static/media/Boots of the Blood Drinker.a796a36f.jpg";